import { HiOutlineUpload } from "react-icons/hi";
import React, { useState, useEffect } from "react";
import { PiFilePdf } from "react-icons/pi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { GrResources } from "react-icons/gr";


const FileList = ({ uploadedFiles, setUploadedFiles, handleFileUpload, handleDeleteFile }) => {
    const [hoveredFile, setHoveredFile] = useState(null); // Track hovered file
    const [clickedFile, setClickedFile] = useState(null); // Track clicked file
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Track dropdown open state

    const handleRenameFile = (index) => {
        const newName = prompt("Enter a new name:", uploadedFiles[index].originalName);
        if (newName && newName.trim()) {
            setUploadedFiles((prevFiles) =>
                prevFiles.map((file, i) =>
                    i === index ? { ...file, originalName: newName.trim() } : file
                )
            );
        }
    };

    // Close dropdown and reset hover on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".dropdown-menu")) {
                setClickedFile(null);
                setIsDropdownOpen(false); // Close dropdown
                setHoveredFile(null); // Reset hover
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    return (
        <div className="w-1/6 bg-gray-100 overflow-y-auto">
            <div className="flex items-center justify-between border-b border-gray-300 pt-5 pb-2 p-2">
                <div className="flex items-center">
                    <h3 className="text-lg mr-2">Sources</h3>
                    <GrResources className="text-black" />
                </div>
                {/* Upload Icon */}
                <label htmlFor="file-upload" className="cursor-pointer hover:bg-white hover:rounded-lg p-2">
                    <HiOutlineUpload className="text-gray-600 hover:text-gray-800" size={20} />
                </label>
                <input
                    id="file-upload"
                    type="file"
                    className="hidden"
                    onChange={handleFileUpload}
                />
            </div>
            <ul className="space-y-2 mt-2">
                {uploadedFiles.map((file, index) => (
                    <li
                        key={index}
                        className={`p-2 rounded flex justify-between items-center relative mr-2 ml-2
                        ${
                            (hoveredFile === index || (clickedFile === index && isDropdownOpen))
                                ? "bg-white bg-opacity-50 shadow-lg"
                                : "bg-transparent"
                        }`}
                        onMouseEnter={() => setHoveredFile(index)} // Set hovered file
                        onMouseLeave={() => {
                            if (!isDropdownOpen || clickedFile !== index) {
                                setHoveredFile(null); // Reset hovered file only if dropdown is not open
                            }
                        }}
                    >
                        {/* File Icon and Name */}
                        <div className="flex items-center">
                            {(hoveredFile === index || (clickedFile === index && isDropdownOpen)) ? (
                                <div
                                    className="p-2 hover:bg-gray-100 rounded-full cursor-pointer hover:shadow-lg"
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent closing immediately
                                        setClickedFile(clickedFile === index ? null : index);
                                        setIsDropdownOpen(clickedFile !== index); // Toggle dropdown state
                                    }}
                                >
                                    <BsThreeDotsVertical className="text-gray-800" />
                                </div>
                            ) : (
                                <div className="p-2">
                                    <PiFilePdf className="text-gray-800" />
                                </div>
                            )}
                            <span className="text-gray-800 text-sm">{file.originalName}</span>
                        </div>

                        {/* Dropdown Menu */}
                        {clickedFile === index && isDropdownOpen && (
                            <div
                                className="absolute bg-white shadow-md rounded z-10 dropdown-menu"
                                style={{
                                    top: "calc(100% + 5px)", // Adjust to position below the three dots
                                    left: "0", // Align with the three dots
                                }}
                            >
                                <ul className="py-1 text-sm text-gray-700">
                                    <li
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        onClick={() => {
                                            handleDeleteFile(file.storedName);
                                            setIsDropdownOpen(false); // Close dropdown after delete
                                        }}
                                    >
                                        Delete
                                    </li>
                                    <li
                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                        onClick={() => {
                                            handleRenameFile(index);
                                            setIsDropdownOpen(false); // Close dropdown after rename
                                        }}
                                    >
                                        Rename
                                    </li>
                                </ul>
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FileList;
